import AllCaseStudiesGrid from "./AllCaseStudiesGrid";

const AllCaseStudiesGridWithProps = ({ blok }) => {
  return <AllCaseStudiesGrid />;
};

export default AllCaseStudiesGridWithProps;
